import { inject, Injectable } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';

/**
 * Single point that wipes per-user state when the session ends (logout, failed token refresh).
 * Every store that holds user data subscribes to `reset$`.
 */
@Injectable({ providedIn: 'root' })
export class SessionLifecycle {
  private readonly resetSubject = new Subject<void>();

  readonly reset$: Observable<void> = this.resetSubject.asObservable();

  reset(): void {
    this.resetSubject.next();
  }
}

/**
 * Ends a stream when the session resets, so a request the previous user started never lands in
 * the next session. Call it in an injection context and reuse the operator it returns.
 */
export function untilSessionReset(): <T>(source: Observable<T>) => Observable<T> {
  const reset$ = inject(SessionLifecycle).reset$;
  return (source) => source.pipe(takeUntil(reset$));
}
